import { Drawer } from 'vaul'

import { DrawerProps } from 'shared/ui/drawer-panel/model.ts'

import s from './styles.module.scss'

export const DrawerPanel = ({
  rootProps,
  triggerProps,
  overlayProps,
  contentProps,
  titleProps,
  descriptionProps,
  trigger,
  title,
  description,
  children,
}: DrawerProps) => {
  return (
    <Drawer.Root {...rootProps}>
      {trigger && <Drawer.Trigger {...triggerProps}>{trigger}</Drawer.Trigger>}
      <Drawer.Portal>
        <Drawer.Overlay
          className={s.overlay}
          {...overlayProps}
        />
        <Drawer.Content
          className={s.content}
          {...contentProps}
          aria-describedby={
            description ? contentProps?.['aria-describedby'] : undefined
          }
        >
          <div
            className={s.handle}
            aria-hidden
          />
          {!title && (
            <Drawer.Title className={s.visuallyHidden}>Информация</Drawer.Title>
          )}
          <div className={s.box}>
            {title && (
              <Drawer.Title
                className={s.title}
                {...titleProps}
              >
                {title}
              </Drawer.Title>
            )}
            {description && (
              <Drawer.Description
                className={s.description}
                {...descriptionProps}
              >
                {description}
              </Drawer.Description>
            )}
            {children}
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
